import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl';
import { useDispatch } from "react-redux";
import ViewTableInformation from '../../../Common/TableRecords/ViewTableInformation';
import ViewTableBodyInformation from '../../../Common/TableRecords/ViewTableBodyInformation';
import { AdminReviewIcon } from '../../..//Common/Assets/SvgComponent/SiteAdminSvgIcon';
import messages from '../../../../locale/messages';
import { decode } from '../../../../helpers/queryEncryption';
import { censorPhone, censorEmail } from '../../../../helpers/secureEmail';
import { demoRestrictionEncode } from '../../../../helpers/DemoRestriction/demoRestriction';

const GuestHostDetails = ({ data }) => {
    const { formatMessage } = useIntl();
    const [isRestrict, setRestrict] = useState('false');
    const dispatch = useDispatch();

    useEffect(() => {
        async function fetchData() {
            const isDemoRestrict = await dispatch(demoRestrictionEncode());
            setRestrict(isDemoRestrict);
        }
        fetchData();
    }, []);

    let guestName, hostName;
    if (data?.guestData) guestName = data?.guestData?.firstName + " " + data?.guestData?.lastName;
    if (data?.hostData) hostName = data?.hostData?.firstName + " " + data?.hostData?.lastName;
    return (
        <div>
            <ViewTableInformation title={formatMessage(messages.guestAndHostDetails)} icon={<AdminReviewIcon />}>
                {data?.guestData?.profileId && <ViewTableBodyInformation
                    title={formatMessage(messages.guestName)}
                    linkText={guestName}
                    linkData={"/users/show/" + data?.guestData?.profileId}
                />}
                {data?.guestUser?.encryptEmail && <ViewTableBodyInformation
                    title={formatMessage(messages.guestEmail)}
                    value={!isRestrict ? decode(data?.guestUser?.encryptEmail) : censorEmail(decode(data?.guestUser?.encryptEmail))}
                />}
                {data?.guestData?.phoneNumber && <ViewTableBodyInformation
                    title={formatMessage(messages.guestPhoneNumber)}
                    value={!isRestrict ? decode(data?.guestData?.phoneNumber) : censorPhone(decode(data?.guestData?.phoneNumber))}
                />}
                {data?.hostData?.profileId && <ViewTableBodyInformation
                    title={formatMessage(messages.hostName)}
                    linkText={hostName}
                    linkData={"/users/show/" + data?.hostData?.profileId}
                />}
                {data?.hostUser?.encryptEmail && <ViewTableBodyInformation
                    title={formatMessage(messages.hostEmailLabel)}
                    value={!isRestrict ? decode(data?.hostUser?.encryptEmail) : censorEmail(decode(data?.hostUser?.encryptEmail))}
                />}
                {data?.hostData?.phoneNumber && <ViewTableBodyInformation
                    title={formatMessage(messages.hostPhoneNumber)}
                    value={!isRestrict ? decode(data?.hostData?.phoneNumber) : censorPhone(decode(data?.hostData?.phoneNumber))}
                />}
            </ViewTableInformation>
        </div>
    )
}

export default GuestHostDetails;

